// services/r2VideoService.js — laluan client ke "pengawal" R2 (Fasa 2 migrasi video).
//
// Suis FAIL-CLOSED (config/r2_video): OFF → laluan Firebase lama, SIFAR perubahan.
// Corak sama subscribeSplitConfig (productService.js). Non-admin yang rules tolak
// baca config → ralat → OFF → Firebase (selamat; R2 mustahil hidup tanpa izin).
import { httpsCallable } from 'firebase/functions';
import { onSnapshot, doc } from 'firebase/firestore';
import { functions, db } from '../firebase';

// ── Suis config/r2_video ──
let _r2Enabled = false;
let _r2Unsub = null;
export function subscribeR2Config() {
  if (_r2Unsub) return;
  try {
    _r2Unsub = onSnapshot(doc(db, 'config', 'r2_video'), (snap) => {
      _r2Enabled = !!(snap.exists() && snap.data().enabled === true);
    }, () => {
      _r2Enabled = false; // ralat baca (cth rules tolak) → OFF = Firebase
      try { _r2Unsub && _r2Unsub(); } catch (_) { /* ignore */ }
      _r2Unsub = null;
    });
  } catch (_) { _r2Enabled = false; }
}
export const isR2Enabled = () => {
  // Suis dev untuk UJIAN (dibuang dari build production, sama corak sesaat_ui_v39):
  // localStorage.sesaat_r2 = '1' → paksa R2 ON di localhost, tanpa sentuh Firestore prod.
  try { if (import.meta.env?.DEV && localStorage.getItem('sesaat_r2') === '1') return true; } catch (_) { /* ignore */ }
  return _r2Enabled;
};

// Kenal URL R2 (routing pull/delete). Padan r2.dev (pilot) atau custom domain (prod).
export const isR2Url = (url) =>
  typeof url === 'string' && (url.includes('.r2.dev/') || url.includes('videos.sesaat.ai/'));

// ── Upload blob video ke R2 melalui pas server (keyless di client) ──
const _issuePass = httpsCallable(functions, 'issueVideoUploadPass', { timeout: 120000 });
export async function uploadVideoToR2(blob, { productId, setKey }) {
  const res = await _issuePass({ productId, setKey, sizeBytes: blob.size });
  const { uploadUrl, publicUrl, objectKey } = res.data || {};
  if (!uploadUrl) throw new Error('R2: pas tidak sah');
  // PUT terus ke R2 guna pas (content-type mesti padan yang ditandatangan).
  const put = await fetch(uploadUrl, { method: 'PUT', headers: { 'Content-Type': 'video/mp4' }, body: blob });
  if (!put.ok) throw new Error(`R2 upload gagal (HTTP ${put.status})`);
  return { url: publicUrl, objectKey };
}

// ── Padam video R2 melalui server (kunci padam di server sahaja) ──
const _deleteR2 = httpsCallable(functions, 'deleteVideoFromR2');
export async function deleteR2Video(url) {
  await _deleteR2({ url });
}

// ── Jumlah bait video R2 milik user (untuk recount butang Optimize) ──
// Senarai bucket R2 dikunci dari client — server yang kira. Gagal = LEMPAR
// (pemanggil WAJIB batalkan tulisan kaunter, bukan tulis Firebase-sahaja).
const _r2Used = httpsCallable(functions, 'getR2StorageUsed', { timeout: 120000 });
export async function getR2UsedBytes() {
  const res = await _r2Used();
  return Number(res?.data?.totalBytes) || 0;
}
